<template>
  <div> 
  <div class="section desc-1">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-lg-6 col-12 order-lg-0 order-1 pr-lg-5">
          <img
            class="about-us-img-service"
            :src="this.publicPath+'assets/images/about_backoffice.png'"
            alt="the ear backoffice"
            title="the ear backoffice"
            loading="lazy"
          />
        </div>
        <div class="col-lg-6 col-12 order-lg-1 order-0">
          <div class="row">
            <div class="col-12">
              <h3 class="title">Back <span class="font-bold">Office</span></h3>
            </div>
            <div class="col-12">
              <p>
                The back office application is a centralized dashboard for our
                entire range of products, allowing you as the operator to manage
                your day-to-day operations and to plan long term strategies —
                our extensive background with gaming operators designed to meet
                technical specification to build and maintain his business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section desc-1">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title">
                Easy <span class="font-bold">Aggregation</span>
              </h3>
            </div>
            <div class="col-12">
              <p>
                The Ear LTD offers you a comprehensive Aggregation solution in
                one API from other providers and our partners. All integrated
                3rd party partners efficiently managed thanks to specific
                features on our Aggregation backend system. As an operator, you
                can view reports, set limits, and control which products are
                shown to your players and many more.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12 order-lg-0 order-1 pl-lg-5">
          <img
            class="about-us-img-service"
            :src="this.publicPath+'assets/images/about_easyintegration.png'"
            alt="product integrations"
            title="product integrations"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="section desc-1">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="video-container col-lg-6 col-12 order-lg-0 order-1 pr-lg-5">
          <video loop autoplay playsinline muted class="video-services mt-5">
            <source :src="this.publicPath+'assets/img/videos/services.mp4'" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div class="col-lg-6 col-12 order-lg-1 order-0">
          <div class="row">
            <div class="col-12">
              <h3 class="title">Back <span class="font-bold">Office</span></h3>
            </div>
            <div class="col-12">
              <h3 class="title text-center">
                Fully hosted and <span class="font-bold"> managed</span>
              </h3>
              <p class="sub-text text-center mb-5">
                The Ear LTD has a wide choice of products, available under a
                lease agreement which allows you to operate the software under
                your license. Since we are also able to manage the hardware and
                hosting sides of the operation, our operators can concentrate
                solely on their core business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section desc-1">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-12">
              <h3 class="title">
                Risk <span class="font-bold">Management</span>
              </h3>
            </div>
            <div class="col-12">
              <p>
                In addition to detailed user profiles administration, the system
                presents a comprehensive history of customer transactions, game
                data, and general user activity, essential to make critical
                business decisions. Our modular approach means that user
                profiles, service, and setting can all be easily limited or
                modified according to the specific situations
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12 pl-lg-5">
          <img
            class="about-us-img-service"
            :src="this.publicPath+'assets/images/about_riskmanagement.png'"
            alt="the ear risk management"
            title="the ear risk management"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="section desc-1">
    <div class="container">
      <div class="row align-items-center" data-aos="fade-up">
        <div class="col-lg-6 col-12 order-lg-0 order-1 pr-lg-5">
          <img
            class="about-us-img-service"
            :src="this.publicPath+'assets/images/about_customerservice.png'"
            alt="the ear customer service"
            title="the ear customer service"
            loading="lazy"
          />
        </div>
        <div class="col-lg-6 col-12 order-lg-1 order-0">
          <div class="row">
            <div class="col-12">
              <h3 class="title">
                Customer <span class="font-bold">Service</span>
              </h3>
            </div>
            <div class="col-12">
              <p>
                Our internal messaging system keeps the player informed and
                facilitates a quick resolution of queries and issues. Messages
                will be queued and made visible in real-time, providing easy
                access to user profiles and statistics.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
export default {
  name: "OurServices",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
    };
  },
  computed: {},
  created() {
   
  },
  methods: {
   
  }, 
};
</script>


<style scoped>
.title {
  text-align: center;
  font-weight: 600;
  line-height: 1.25;
}
.section {
  /* margin: 40px 0px 40px; */
  margin: 70px 0px 70px;
}

.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-services {
  width: 100%;
  max-width: 492px;
}

.about-us-img-service {
  width: 100%;
  height: auto;
  max-height: 330px;
  -o-object-fit: contain;
  object-fit: contain;
  aspect-ratio: 4/3;
}

.container img {
  min-height: 100px;
}

p {
  margin-top: 30px;
  margin-bottom: 40px;
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #160f1d;
  min-height: 60px;
}

@media (max-width: 992px) {
  .container {
    padding: 0 30px;
  }
}
</style>
